export enum SortType {
  Default = "Default",
  Price = "Precio",
  High = "High",
  Low = "Low",
  Stars = "Stars",
}
